import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SetPasswordPublic() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, valid: false });
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setState({ loading: false, valid: false, reason: "Lien invalide." }); return; }
    axios.get(`${API}/auth/invitations/verify`, { params: { token } })
      .then((r) => setState({ loading: false, ...r.data }))
      .catch(() => setState({ loading: false, valid: false, reason: "Lien invalide." }));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) { setError("Le mot de passe doit contenir au moins 8 caractères."); return; }
    if (pwd !== pwd2) { setError("Les deux mots de passe ne correspondent pas."); return; }
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/invitations/accept`, { token, password: pwd });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Une erreur est survenue.");
    }
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-100 p-6" data-testid="set-password-page">
      <div className="w-full max-w-md bg-zinc-900 border border-zinc-800 rounded-2xl p-8">
        <div className="text-center mb-6">
          <div className="text-2xl font-black"><span className="text-red-500">KAIZEN</span> <span className="text-amber-500">SYSTEM</span></div>
          <div className="text-xs text-zinc-500 mt-1 uppercase tracking-widest">Institut Impact Élite Martial</div>
        </div>

        {state.loading && <p className="text-center text-zinc-400">Vérification du lien…</p>}

        {!state.loading && !state.valid && !done && (
          <div className="text-center space-y-4" data-testid="set-password-invalid">
            <div className="text-5xl">⛔</div>
            <p className="text-amber-400 font-semibold">{state.reason || "Lien invalide ou expiré."}</p>
            <p className="text-sm text-zinc-400">Demande un nouveau lien d'invitation à l'administrateur.</p>
          </div>
        )}

        {!state.loading && state.valid && !done && (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-zinc-300">
              Bienvenue <strong>{state.full_name}</strong> 👋<br />
              Définis ton mot de passe personnel pour ton accès <span className="text-amber-400">{state.role_label}</span>.
            </p>
            <div className="text-xs text-zinc-500">{state.email}</div>
            <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Nouveau mot de passe (8+ caractères)"
              data-testid="set-password-input" className="w-full px-4 py-3 rounded-lg bg-zinc-800 border border-zinc-700 focus:border-amber-500 outline-none text-sm" />
            <input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} placeholder="Confirme le mot de passe"
              data-testid="set-password-confirm" className="w-full px-4 py-3 rounded-lg bg-zinc-800 border border-zinc-700 focus:border-amber-500 outline-none text-sm" />
            {error && <p className="text-sm text-red-400" data-testid="set-password-error">{error}</p>}
            <button type="submit" disabled={submitting} data-testid="set-password-submit"
              className="w-full py-3 rounded-lg bg-amber-500 hover:bg-amber-400 text-zinc-950 font-bold disabled:opacity-50 transition">
              {submitting ? "Enregistrement…" : "Définir mon mot de passe"}
            </button>
          </form>
        )}

        {done && (
          <div className="text-center space-y-4" data-testid="set-password-success">
            <div className="text-5xl">✅</div>
            <p className="text-green-400 font-semibold">Mot de passe enregistré !</p>
            <p className="text-sm text-zinc-400">Tu peux maintenant te connecter avec ton courriel et ton nouveau mot de passe.</p>
            <Link to="/auth" className="inline-block px-5 py-2.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-zinc-950 font-bold transition">Se connecter</Link>
          </div>
        )}
      </div>
    </div>
  );
}
